import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

export enum Icons {
  AIRPLANE = 'airplane',
  ARROW_LEFT = 'arrow-left',
  ARROW_LEFT_IN_CIRCLE = 'arrow-left-in-circle',
  ARROW_RIGHT_IN_CIRCLE = 'arrow-right-in-circle',
  ARROW_LEFT_IN_CIRCLE_SMALL = 'arrow-left-in-circle-small',
  ARROW_RIGHT_IN_CIRCLE_FILLED = 'arrow-right-in-circle-filled',
  BADGE = 'badge',
  BELL = 'bell',
  CHECK = 'check',
  CALENDAR = 'calendar',
  CHECK_CIRCLE = 'check-circle',
  CHECK_IN_CIRCLE_FILLED = 'check-in-circle-filled',
  CHEVRON_DOWN = 'chevron-down',
  CHEVRON_LEFT = 'chevron-left',
  CHEVRON_RIGHT = 'chevron-right',
  CLOCK = 'clock',
  CLOSE = 'close',
  CLOSE_IN_CIRCLE_FILLED = 'close-in-circle-filled',
  DELETE_WITH_BACKGROUND = 'delete-with-background',
  DOWNLOAD = 'download',
  EDIT = 'edit',
  ERROR = 'error',
  FILE = 'file',
  HOME = 'home',
  INFO_THICK = 'info-thick',
  INFO_THIN = 'info-thin',
  LEAF = 'leaf',
  LOGOUT = 'logout',
  MAIL = 'mail',
  MAP_PIN = 'map-pin',
  MENU = 'menu',
  MESSAGE = 'message',
  MINUS = 'minus',
  MINUS_IN_CIRCLE = 'minus-in-circle',
  PHONE = 'phone',
  PIGGY_BANK = 'piggy-bank',
  PLUS = 'plus',
  PLUS_IN_CIRCLE = 'plus-in-circle',
  REWARD = 'reward',
  TREE = 'tree',
  USER = 'user',
  SUCCESS = 'success',
  WARNING = 'warning',
  X = 'x',
}

@Injectable({
  providedIn: 'root',
})
export class SharedFeatureIconsService {
  private readonly matIconRegistry = inject(MatIconRegistry);
  private readonly domSanitizer = inject(DomSanitizer);

  registerIcons(): void {
    this.loadIcons(Object.values(Icons), 'assets/icons');
  }

  private loadIcons(iconKeys: Icons[], iconUrl: string): void {
    iconKeys.forEach((key) => {
      this.matIconRegistry.addSvgIcon(key, this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconUrl}/${key}.svg`));
    });
  }
}
